export interface PrintOperationError extends Error {
    retryable: boolean;
    deliveryUncertain: boolean;
}

interface PrintOperationErrorOptions {
    retryable?: boolean;
    deliveryUncertain?: boolean;
}

export function criarErroImpressao(
    message: string,
    { retryable = true, deliveryUncertain = false }: PrintOperationErrorOptions = {},
): PrintOperationError {
    const error = new Error(message) as PrintOperationError;
    error.name = 'PrintOperationError';
    error.retryable = retryable;
    error.deliveryUncertain = deliveryUncertain;
    return error;
}

export function permiteRetryImpressao(error: unknown): boolean {
    return !error || typeof error !== 'object' || (error as Partial<PrintOperationError>).retryable !== false;
}

/**
 * Impede que uma Promise de plugin que não responde bloqueie a fila para sempre.
 * A operação nativa pode não ser cancelável; por isso o chamador define se o
 * timeout aconteceu antes do envio (retry seguro) ou durante o envio (incerto).
 */
export function executarComTimeout<T>(
    operacao: () => PromiseLike<T>,
    timeoutMs: number,
    criarErro: () => Error = () => criarErroImpressao(`Timeout após ${timeoutMs}ms`),
): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        let finalizado = false;

        const finalizar = (callback: () => void) => {
            if (finalizado) return;
            finalizado = true;
            clearTimeout(timeoutId);
            callback();
        };

        const timeoutId = setTimeout(() => {
            finalizar(() => reject(criarErro()));
        }, timeoutMs);

        try {
            Promise.resolve(operacao()).then(
                value => finalizar(() => resolve(value)),
                error => finalizar(() => reject(error)),
            );
        } catch (error) {
            finalizar(() => reject(error));
        }
    });
}
